export default __webpack_public_path__ + "static/media/hero.3bdac87a.png";